import cssModule from "@vercel/turbopack-next/internal/font/google/cssmodule.module.css?{%22path%22:%22fonts.ts%22,%22import%22:%22Love_Ya_Like_A_Sister%22,%22arguments%22:[{%22subsets%22:[%22latin%22],%22weight%22:%22400%22,%22display%22:%22swap%22,%22preload%22:false}],%22variableName%22:%22loveYa%22}";
const fontData = {
    className: cssModule.className,
    style: {
        fontFamily: "'Love Ya Like A Sister', 'Love Ya Like A Sister Fallback'",
        fontWeight: 400,
fontStyle: "normal",

    },
};

if (cssModule.variable != null) {
    fontData.variable = cssModule.variable;
}

export default fontData;
